/* =============================================================
   EC CART ENGINE  ·  shared by /cart page AND the cart drawer
   Order note · terms gate · free-gift auto add/remove · upsells.
   Uses delegated document listeners, so it drives whichever cart
   markup is on the page. Guarded so it only wires once.
   ============================================================= */
(function () {
  if (window.__ecCartWired) return;
  window.__ecCartWired = true;

  var termsAccepted = false;
  var giftBusy = false;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ---------- Order note ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-note-toggle]');
    if (!t) return;
    var note = t.closest('.ec-cart-note');
    var panel = note && note.querySelector('.ec-cart-note__panel');
    if (!panel) return;
    var open = panel.hasAttribute('data-open');
    if (open) { panel.removeAttribute('data-open'); t.setAttribute('aria-expanded', 'false'); }
    else { panel.setAttribute('data-open', ''); t.setAttribute('aria-expanded', 'true'); var ta = panel.querySelector('textarea'); if (ta) ta.focus(); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-cart-note]')) {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
    }
  });

  /* ---------- Terms gate ---------- */
  function applyTerms() {
    var box = document.querySelector('[data-terms-checkbox]');
    var btn = document.querySelector('[data-checkout-btn]');
    if (box) box.checked = termsAccepted;
    if (btn) btn.disabled = !termsAccepted;
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-terms-checkbox]')) {
      termsAccepted = e.target.checked;
      applyTerms();
    }
  });

  /* ---------- Free gift auto add / remove ---------- */
  function syncGift() {
    if (giftBusy) return;
    var p = document.querySelector('[data-cart-progress]');
    if (!p) return;
    // Gift feature off: remove any leftover gift line item (gift items have no remove button).
    if (p.getAttribute('data-gift-enabled') !== 'true') {
      var stray = document.querySelector('[data-gift-item]');
      if (stray && stray.getAttribute('data-id')) {
        giftBusy = true;
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: stray.getAttribute('data-id'), quantity: 0 }) })
          .then(function () { return window.refreshCart ? window.refreshCart() : location.reload(); })
          .finally(function () { giftBusy = false; });
      }
      return;
    }
    var variant = p.getAttribute('data-gift-variant');
    if (!variant) return;
    var threshold = parseInt(p.getAttribute('data-gift-threshold'), 10) || 0;
    var base = parseInt(p.getAttribute('data-base-subtotal'), 10) || 0;
    var inCart = p.getAttribute('data-gift-in-cart') === 'true';
    var eligible = base >= threshold;

    if (eligible && !inCart) {
      giftBusy = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variant, 10), quantity: 1, properties: { _gift: 'true' } }) })
        .then(function () { return window.refreshCart ? window.refreshCart() : location.reload(); })
        .finally(function () { giftBusy = false; });
    } else if (!eligible && inCart) {
      giftBusy = true;
      var giftEl = document.querySelector('[data-gift-item]');
      var key = giftEl && giftEl.getAttribute('data-id');
      if (key) {
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }) })
          .then(function () { return window.refreshCart ? window.refreshCart() : location.reload(); })
          .finally(function () { giftBusy = false; });
      } else { giftBusy = false; }
    }
  }

  /* ---------- Upsells ---------- */
  var upsellsLoaded = false;
  function loadUpsells() {
    var mount = document.querySelector('[data-upsells]');
    var track = document.querySelector('[data-upsells-track]');
    if (!mount || !track || upsellsLoaded) return;
    var firstItem = document.querySelector('#AjaxCartForm [data-js-cart-item]:not([data-gift-item])');
    if (!firstItem) return;
    upsellsLoaded = true;
    var pid = firstItem.getAttribute('data-product-id');
    var inCart = {};
    document.querySelectorAll('#AjaxCartForm [data-js-cart-item]').forEach(function (el) { inCart[el.getAttribute('data-product-id')] = true; });
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.products || []).filter(function (p) {
          if (inCart[p.id] || p.available === false) return false;
          // Only individual products — exclude bundles/sets (tagged gift-sets, or Duo/Trio/Collection/Kit in the title).
          var title = (p.title || '').toLowerCase();
          var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
          var isBundle = tags.indexOf('gift-sets') !== -1 || /\b(duo|trio|collection|kit|set|bundle)\b/.test(title);
          return !isBundle;
        }).slice(0, 6);
        if (!products.length) { upsellsLoaded = false; return; }
        track.innerHTML = products.map(function (p) {
          var v = (p.variants || []).find(function (x) { return x.available; }) || (p.variants || [])[0] || {};
          var priceCents = typeof v.price === 'number' ? v.price : Math.round(parseFloat(v.price || p.price || 0) * 100);
          var img = p.featured_image || (p.images && p.images[0]) || '';
          if (img && img.indexOf('http') !== 0 && img.indexOf('//') !== 0) img = img;
          var priceStr = money(priceCents);
          return '<div class="ec-upsell">' +
            '<a class="ec-upsell__img" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
            '<div class="ec-upsell__info">' +
              '<a class="ec-upsell__title" href="' + p.url + '">' + p.title + '</a>' +
            '</div>' +
            '<button type="button" class="ec-upsell__add" data-upsell-add="' + (v.id || '') + '" data-price="' + priceStr + '" aria-label="Add ' + p.title + '">Add <span class="ec-btn-separator">·</span> <span class="ec-btn-price">' + priceStr + '</span></button>' +
          '</div>';
        }).join('');
        mount.hidden = false;
        setupUpsellArrows(mount);
      })
      .catch(function () { upsellsLoaded = false; });
  }

  /* ---------- Upsell scroll arrows ---------- */
  function updateUpsellArrows(mount) {
    var track = mount.querySelector('[data-upsells-track]');
    var arrows = mount.querySelector('.ec-upsells__arrows');
    var prev = mount.querySelector('[data-upsells-prev]');
    var next = mount.querySelector('[data-upsells-next]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth - 1;
    if (arrows) arrows.style.display = max > 2 ? '' : 'none'; // hide if nothing to scroll
    if (prev) prev.disabled = track.scrollLeft <= 0;
    if (next) next.disabled = track.scrollLeft >= max;
  }
  function setupUpsellArrows(mount) {
    var track = mount.querySelector('[data-upsells-track]');
    if (!track || track.__ecArrows) { if (track) updateUpsellArrows(mount); return; }
    track.__ecArrows = true;
    track.addEventListener('scroll', function () { updateUpsellArrows(mount); });
    window.addEventListener('resize', function () { updateUpsellArrows(mount); });
    setTimeout(function () { updateUpsellArrows(mount); }, 60);
  }
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-upsells-prev], [data-upsells-next]');
    if (!arrow) return;
    var mount = arrow.closest('[data-upsells]');
    var track = mount && mount.querySelector('[data-upsells-track]');
    if (!track) return;
    var card = track.querySelector('.ec-upsell');
    var step = (card ? card.getBoundingClientRect().width + 12 : 150) * 1.5;
    track.scrollBy({ left: (arrow.hasAttribute('data-upsells-next') ? 1 : -1) * step, behavior: 'smooth' });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-upsell-add]');
    if (!b) return;
    var id = b.getAttribute('data-upsell-add');
    if (!id) return;
    b.classList.add('is-loading'); b.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }) })
      .then(function () { upsellsLoaded = false; return window.refreshCart ? window.refreshCart() : location.reload(); })
      .then(function () { setTimeout(afterCartChange, 60); });
  });

  /* ---------- Re-sync after every cart mutation ---------- */
  function afterCartChange() { applyTerms(); syncGift(); loadUpsells(); }

  function bind() {
    var cf = document.getElementById('AjaxCartForm');
    if (cf && !cf.__ecBound) { cf.__ecBound = true; cf.addEventListener('cart-updated', function () { setTimeout(afterCartChange, 30); }); }
  }

  document.addEventListener('DOMContentLoaded', function () { bind(); afterCartChange(); });
  if (document.readyState !== 'loading') { bind(); afterCartChange(); }

  /* ---------- Promo / discount code ----------
     Shopify applies a code via GET /discount/{code} (sets it on the cart
     session). We then refresh and confirm success by checking the cart's
     total_discount actually went up — an invalid code changes nothing. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-promo-apply]');
    if (!btn) return;
    var wrap = btn.closest('.ec-promo');
    var input = wrap && wrap.querySelector('[data-promo-input]');
    var code = input && input.value.trim();
    var msg = document.querySelector('[data-promo-msg]');
    function say(text, ok) {
      if (!msg) return;
      msg.textContent = text;
      msg.className = 'ec-promo__msg ' + (ok ? 'is-success' : 'is-error');
      msg.hidden = false;
    }
    if (!code) { say('Enter a code.', false); return; }
    btn.disabled = true; var label = btn.textContent; btn.textContent = '…';

    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (before) {
      var beforeDisc = before.total_discount || 0;
      return fetch('/discount/' + encodeURIComponent(code), { method: 'GET' })
        .then(function () { return window.refreshCart ? window.refreshCart() : null; })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (after) {
          if ((after.total_discount || 0) > beforeDisc) {
            say('Code applied!', true);
            if (input) input.value = '';
          } else {
            say('That code isn’t valid for this cart.', false);
          }
        });
    })
      .catch(function () { say('Something went wrong. Try again.', false); })
      .finally(function () { btn.disabled = false; btn.textContent = label; });
  });

  /* expose for the drawer engine to re-bind after content swaps */
  window.ecCartAfterChange = function () { bind(); afterCartChange(); };
})();
